import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import type { TNDVIImageColumnProps } from './types'

export const NDVIImageColumn = ({ src, blockId, title, metrics }: TNDVIImageColumnProps) => (
  <div css={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <img
      src={src}
      alt={translate.phrases.banyanApp('NDVI image for block {{blockId}}', { blockId })}
      css={{ width: '100%', height: 'auto', marginBottom: 10 }}
    />
    <div
      css={{
        padding: 8,
        backgroundColor: colors.grey50,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div css={{ fontWeight: 'bold', fontSize: 12, marginBottom: 10, textAlign: 'center' }}>{title}</div>
      <div css={{ marginTop: 10 }}>
        {metrics.map((metric, index) => (
          <div
            key={metric.label}
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: 12,
              marginBottom: index < metrics.length - 1 ? 5 : 0,
            }}
          >
            <div>{metric.label}</div>
            <div>{metric.value}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
)
